import * as React from 'react';
import { Dialog, DialogTitle, DialogProps, Typography, IconButton } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { Theme } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    title: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    }
  })
);

interface SampleDialogProps extends DialogProps {
  open: boolean;
  toggle: () => void;
  children: React.ReactNode;
  title?: string;
}

/**
 *
 * 
 */
export default function SampleDialog(props: SampleDialogProps) {
  const {
    open, toggle,
    children,
    title,
    ...rest
  } = props;
  const classes = useStyles();
  const handleClose = (event, reason) => {
  };

  return (
    <Dialog
      maxWidth="sm"
      open={open}
      // onClose={toggle}
      // disableBackdropClick
      onClose={handleClose}
      fullWidth
      {...rest}
    >
      {title && <DialogTitle
        className={classes.title}
      >
        <span>{title}</span>
        <IconButton
          aria-label="close"
          size='small'
          onClick={toggle}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>}
      {
        children
      }
    </Dialog>
  );
}
